module.exports = __webpack_public_path__ + "img/komodaru_catch.ce3e1d70.png";